/*
 * Adapptio Editor
 *
 * @package editor
 * @copyright 2021-2025 Hexio a.s. <contact@hexio.io> (hexio.io) and contributors.
 * @license Apache-2.0
 *
 * See LICENSE file distributed with this source code for more information.
 */

import React from "react";
import { BEM } from "@adapptio/lib-components";

import "./FieldRow.scss";

export interface IFieldRowProps {
	className?: string;
	children?: React.ReactNode;
	onClick?: React.MouseEventHandler;
}

export const FieldRow: React.FC<IFieldRowProps> = ({ children, className, onClick }) => {
	const baseClass = BEM("edt-field-row");

	if (className) {
		baseClass.add(className);
	}

	return (
		<div className={baseClass.toClassName()} onClick={onClick}>
			{children}
		</div>
	);
};
